import {Model} from './model';

export class ClientRepresentative implements Model {
  clientRepresentativeId: number;
  clientId: number;
  ssn: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  created: Date;

  static copy(oldObj: ClientRepresentative): ClientRepresentative {
    const newObj = new ClientRepresentative();
    newObj.copyFrom(oldObj);
    return newObj;
  }

  public getPrimaryKey(): number {
    return this.clientRepresentativeId;
  }

  isNew(): boolean {
    return isNaN(this.clientRepresentativeId);
  }

  copyFrom(another: ClientRepresentative) {
    this.clientRepresentativeId = another.clientRepresentativeId;
    this.clientId = another.clientId;
    this.ssn = another.ssn;
    this.firstName = another.firstName;
    this.lastName = another.lastName;
    this.email = another.email;
    this.phone = another.phone;
    this.created = another.created;
  }

  clone(): ClientRepresentative {
    return ClientRepresentative.copy(this);
  }
}
